import * as BABYLON from 'babylonjs';
import Vec3 from "../../../shared/vec3";
import { Orientation } from '../../../shared/interfaces'

export default class ImagePlane {

  planeHolder: BABYLON.TransformNode;

  constructor(url: string, position: Vec3, orientation: Orientation, scene: BABYLON.Scene) {
    const height = 1.5;
    const width = 1.5;

    let angle = 0;
    let xOffset = 0;
    let zOffset = 0;
    const wallDistance = 0.01;

    switch (orientation) {
      case Orientation.NORTH:
        angle = 0;
        xOffset = 1 - wallDistance;
        zOffset = 0;
        break;
      case Orientation.EAST:
        angle = 0.5 * Math.PI;
        xOffset = 0;
        zOffset = 1 - wallDistance
        break;
      case Orientation.SOUTH:
        angle = Math.PI;
        xOffset = -1 + wallDistance;
        zOffset = 0;
        break;
      case Orientation.WEST:
        angle = 1.5 * Math.PI;
        xOffset = 0;
        zOffset = -1 + wallDistance;
        break;
    }

    const plane = BABYLON.MeshBuilder.CreatePlane("imagePlane_" + url, { height: height, width: width }, scene);
    plane.rotationQuaternion = BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0, 1, 0), angle);

    const imageMaterial = new BABYLON.StandardMaterial("image_" + url, scene);
    imageMaterial.diffuseTexture = new BABYLON.Texture(url, scene)
    plane.material = imageMaterial;

    this.planeHolder = new BABYLON.TransformNode('planerHolder_' + url);
    plane.parent = this.planeHolder;

    this.planeHolder.position.x = position.x + zOffset;
    this.planeHolder.position.y = position.y + height / 2;
    this.planeHolder.position.z = position.z + xOffset;
  }

  getMesh() {
    return this.planeHolder;
  }

}
